export const OWNER_PROFILE = {
  name: "Team SG Prop Portal",
  title: "Property Advisory Team",
  email: "contact@sgpropportal.com",
  bio: "Trusted guidance from Team SG Prop Portal for Singapore buyers, landlords, and families seeking strategic, well-positioned homes.",
  heroImage:
    "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1200&q=80",
};

export const PORTAL_CONTACT = {
  whatsappDisplay: "+65 9131 1598",
  whatsappDigits: "6591311598",
  email: "contact@sgpropportal.com",
  leadFormPath: "/contact",
};

export const BRAND_TAGLINE = "Your Gateway to Singapore’s Finest Addresses.";
export const PORTFOLIO_SOURCE_NOTE = "Information sourced from Team SG Prop Portal's PropNex portfolio.";

export const SITE_LOGO_URL =
  "/icons/sg-prop-portal-gold-192.png";

export const HEADER_WORDMARK_URL =
  "https://customer-assets.emergentagent.com/job_sg-prop-agent/artifacts/6nt7spq1_SGPropPortal%20logo..png";

export const AGENT_PORTAL_WORDMARK_URL =
  "/agent-portal-logo-cropped.png";

export const HERO_BACKGROUND =
  "https://images.unsplash.com/photo-1701733246093-619faa7e16fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxzaW5nYXBvcmUlMjBsdXh1cnklMjBwcm9wZXJ0eXxlbnwwfHx8fDE3NzUxMzQ5MzF8MA&ixlib=rb-4.1.0&q=85";

export const ALL_DISTRICTS = Array.from({ length: 28 }, (_, index) => `D${String(index + 1).padStart(2, "0")}`);
export const MARKET_INSIGHTS_PDF = "/2026-market-insights.pdf";

export const NAV_LINKS = [
  { label: "About Us", href: "/about", global: true },
  { label: "Buy", href: "/buy" },
  { label: "Rent", href: "/rent" },
  { label: "Sell", href: "/sell" },
  { label: "New Launches", href: "/new-launches" },
  { label: "For Agents", href: "/for-agents", global: true, emphasis: true },
  { label: "Financials", href: "/financials" },
  { label: "Market Insights", href: "/insights" },
];

export const FOOTER_LINKS = [
  { label: "Buy", href: "/buy" },
  { label: "Rent", href: "/rent" },
  { label: "Sell", href: "/sell" },
  { label: "Lease Out", href: "/lease-out" },
  { label: "For Agents", href: "/for-agents" },
  { label: "Pricing", href: "/pricing" },
  { label: "Contact", href: "/contact" },
  { label: "Admin", href: "/admin/login" },
];

export const QUICK_DISTRICTS = ALL_DISTRICTS;

export const HIGHLIGHTS = [
  { label: "Live search districts", value: "28" },
  { label: "Bespoke Portfolio Oversight", value: "Team" },
  { label: "Real-Time Market Intelligence", value: "Live" },
];

export const getWhatsAppLink = (message = "Hello, I’d like to enquire about a property.") =>
  `https://wa.me/${PORTAL_CONTACT.whatsappDigits}?text=${encodeURIComponent(message)}`;

export const getLeadFormLink = () => PORTAL_CONTACT.leadFormPath;